// import ally from 'ally.js';

// export let keepFocusInMenu;
import { getParams } from './getParams';

/**
 * Get the width of the scrollbar
 */
function getScrollbarWidth() {
  // Create the measurement node
  const scrollDiv = document.createElement('div');
  const root = document.documentElement;

  scrollDiv.className = 'scrollbar-measure';
  document.body.appendChild(scrollDiv);

  // Get the scrollbar width
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  // Add it as a custom property
  root.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');

  // Delete the DIV
  document.body.removeChild(scrollDiv);
}

export function getMenuElements() {
  const menuElements = {
    menuToggle: document.querySelector('.js-menu-toggle'),
    overlayMenu: document.querySelector('.js-overlay-menu'),
    body: document.querySelector('body'),
    menuClosers: document.querySelectorAll('.js-menu-close'),
    menuBlur: document.querySelector('.js-menu-blur'),
    menuCloseBtn: document.querySelector('.menu__closebtn'),
  };

  return menuElements;
}

function closeOverlayMenu() {
  const { menuToggle, overlayMenu, body, menuBlur } = getMenuElements();

  body.classList.remove('overlay-menu-open');
  menuToggle.setAttribute('aria-expanded', 'false');
  overlayMenu.classList.remove('is-open');
  menuBlur.classList.remove('visible');
  menuToggle.focus();
  // Allow focus of other elements again
  // keepFocusInMenu.disengage();
  // keepFocusInMenu = null;
}

function openOverlayMenu() {
  const { menuToggle, overlayMenu, body, menuBlur, menuCloseBtn } =
    getMenuElements();

  body.classList.add('overlay-menu-open');
  menuToggle.setAttribute('aria-expanded', 'true');
  overlayMenu.classList.add('is-open');
  menuBlur.classList.add('visible');
  menuCloseBtn.focus();
  // Keep focus in menu by making everything else inert
  // keepFocusInMenu = ally.maintain.disabled({
  //   context: root,
  //   filter: overlayMenu,
  // });
}

export function isOverlayMenuOpen() {
  const { body } = getMenuElements();
  const isOpen = body.classList.contains('overlay-menu-open');

  return isOpen;
}

function toggleOverlayMenu() {
  if (isOverlayMenuOpen()) {
    closeOverlayMenu();
  } else {
    openOverlayMenu();
  }
}

// Toggle button
function setupMenuButtons() {
  const { menuToggle, overlayMenu, menuClosers } = getMenuElements();

  if (overlayMenu && menuToggle) {
    menuToggle.addEventListener('click', toggleOverlayMenu);
  }

  // Close buttons
  if (overlayMenu && menuClosers) {
    for (let i = 0; i < menuClosers.length; i++) {
      menuClosers[i].addEventListener('click', closeOverlayMenu);
    }
  }

  // Esc key to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOverlayMenuOpen()) {
      closeOverlayMenu();
    }
  });
}

// ----------------------
// Current page indicator
// ----------------------
function currentPageIndicator() {
  let currentPage = '';
  /* eslint-disable no-undef */
  if (typeof setCurrentPage !== 'undefined') {
    currentPage = setCurrentPage;
  }
  // let currentSection = '';
  /* eslint-disable no-undef */
  // if (typeof setCurrentSection !== 'undefined') {
  // currentSection = setCurrentSection;
  // }

  // Add class to current link
  if (typeof currentPage !== 'undefined' && currentPage) {
    const page = document.querySelector(
      '.js-nav-link[data-slug="' + currentPage + '"]'
    );
    if (page) {
      page.classList.add('is-here');
    }
  }

  // Check for category filter
  const params = getParams(window.location.href);
  if (params.category) {
    const cat = document.querySelector(
      '.js-nav-link[data-slug="' + params.category + '"]'
    );
    if (cat) {
      cat.classList.add('is-here');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  getScrollbarWidth();

  setupMenuButtons();

  currentPageIndicator();
});
